export default __webpack_public_path__ + "static/media/dice.59b678f9.png";